// Node Modules
import React from "react";

// Global Contexts
import { ShoppingCartContext } from "contexts/shoppingCartContext.js";

// Global Components
import Link from "components/link/link";

// Global Assets
import logo from "assets/images/logo.png";

// Local Assets
import LineItem from "./components/lineItem/lineItem";
import Checkout from "./components/checkout/checkout";
import EmptyCart from "./components/emptyCart/emptyCart";

// Local Styling
import "./cart.css";
import "./cart-mobile.css";

class Cart extends React.Component {
  render() {
    return (
      <div className="cart">
        <div className="logo-container">
          <Link to="/">
            <img style={{ maxWidth: "100%" }} src={logo} />
          </Link>
        </div>
        <ShoppingCartContext.Consumer>
          {({ checkout, updateLineItems }) => {
            if (
              checkout.lineItems === null || checkout.lineItems === undefined ||
              checkout.lineItems.length === 0
            ) {
              return (
                <div className="items">
                  <EmptyCart />
                </div>
              );
            }
            return (
              <div className="items">
                {checkout.lineItems.map(lineItem => (
                  <LineItem
                    lineItem={lineItem}
                    key={lineItem.id}
                    updateLineItems={updateLineItems}
                  />
                ))}
                <Checkout url={checkout.webUrl} />
              </div>
            );
          }}
        </ShoppingCartContext.Consumer>
      </div>
    );
  }
}
export default Cart;
